const STORAGE_KEY = 'ralphWidgetAction'

export function saveWidgetAction(action) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(action))
  } catch {
    // ignore
  }
}

export function peekWidgetAction() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function consumeWidgetAction() {
  const action = peekWidgetAction()
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
  return action
}

export function decodeWidgetPayloadParam(raw) {
  if (!raw) return null
  try {
    const json = decodeURIComponent(escape(atob(String(raw))))
    return JSON.parse(json)
  } catch {
    try {
      return JSON.parse(decodeURIComponent(String(raw)))
    } catch {
      return null
    }
  }
}

export function readWidgetActionFromUrl(search = window.location.search) {
  try {
    const params = new URLSearchParams(search)
    const action = params.get('widget')
    if (!action) return null
    const payload = decodeWidgetPayloadParam(params.get('wpayload')) || {}
    return {
      source: 'ralph-widget-bridge',
      type: 'widget-open',
      action,
      payload,
      at: Number(params.get('wts')) || Date.now(),
    }
  } catch {
    return null
  }
}

export function isWidgetOpenMessage(data) {
  if (!data || data.type !== 'widget-open') return false
  if (data.source === 'ralph-widget' || data.source === 'ralph-widget-bridge') return true
  // Handoff SPA do cassino pode reenviar o detail sem source
  return !!(data.action && data.payload)
}
